import React from "react";

export interface DummySettings {}
export interface DummySettingsState {
  settings: DummySettings;
  updateSettings: (newSettings: Partial<DummySettings>) => void;
  isDirty: boolean;
}
const defaultState: DummySettingsState = {
  settings: {
    fullName: "Annette Black",
    email: "annette.black@boxem.com",
  },
  updateSettings: () => {},
  isDirty: true,
};

const SettingsContext = React.createContext<DummySettingsState>(defaultState);

export const SettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const [settings, setSettings] = React.useState<DummySettings>(defaultState.settings);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);

  const updateSettings = (newSettings: Partial<DummySettings>) => {
    setSettings((prevSettings) => {
      const updatedSettings = { ...prevSettings, ...newSettings };
      setIsDirty(JSON.stringify(updatedSettings) !== JSON.stringify(defaultState.settings));
      return updatedSettings;
    });
  };

  return <SettingsContext.Provider value={{ settings, updateSettings, isDirty }}>{children}</SettingsContext.Provider>;
};

export default SettingsContext;
